import Glide from "@glidejs/glide";
import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MultiGLightbox } from "../../common/image_gallery.js";
import { yieldToMainBackground } from "../../common/utils.js";
import { MpVideoPlayer } from "../../common/video_player.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		// Lightbox gamecard galleria associata
		const gallery_data = document.querySelector("#_gallery-section");
		if (gallery_data) {
			const main_gallery = new MultiGLightbox({
				url: gallery_data.dataset.mainGalleryUrl,
				per_page: 20,
				selector: gallery_data.dataset.gallerySelector,
			});
		}

		// Video carousel
		const videoSlider = document.querySelector("#_video_slider");
		if (videoSlider) {
			if (is_ready) addVideoEventListener(multiJWP);
			const videoCarousel = new Glide(".glide", {
				gap: 16,
				type: "slider",
				perView: 4.5,
				keyboard: false,
				rewind: false,
				bound: true,
				focusAt: 0,
				breakpoints: {
					1024: {
						perView: 3.5,
					},
					992: {
						perView: 3.5,
					},
					750: {
						perView: 2.5,
					},
					576: {
						perTouch: false,
						perView: 1.5,
					},
				},
			});
			videoCarousel.on("run.after", (event) => {
				const last_slide_index = Array.from(
					document.querySelectorAll(".glide__slide"),
				).findLastIndex((element) => element);
				const perPage = videoCarousel.settings.perView - 0.5;
				if (videoCarousel.index + perPage === last_slide_index) {
					const endless = document.querySelector(".endless_more");
					if (endless) endless.click();
				}
			});

			videoCarousel.mount();

			// paginated carousel videos
			endlessPaginate({
				moreSelector: "span.endless_more",
				moreSelectorDataUrl: "data-more",
				onCompleted: (context, fragment) => {
					if (is_ready) addVideoEventListener(multiJWP);
					videoCarousel.update();
				},
			});
		}
	});
});

function addVideoEventListener(multiJWP) {
	const firstVideo = document.querySelector("#_video_slot");
	const videoContainer = firstVideo.querySelector(".embed-responsive-item");
	for (const video of document.querySelectorAll(
		".video-grid__item:not(#_video_slot) a",
	)) {
		video.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;

			// se il video cliccato è quello in play skip
			if (target.dataset.video_id === videoContainer.dataset.video_id) return;

			// remove current player
			let current_player = jwplayer(
				`_video_${videoContainer.dataset.video_id}`,
			);
			if (Object.prototype.hasOwnProperty.call(current_player, "remove")) {
				current_player.remove();
			}
			current_player = null;
			while (videoContainer.firstChild) {
				videoContainer.removeChild(videoContainer.firstChild);
			}

			// load new player
			firstVideo
				.querySelector(".embed-responsive-item")
				.insertAdjacentHTML(
					"beforeend",
					`<div id="_video_${target.dataset.video_id}" data-video_id="" data-video_uid=""></div>`,
				);

			yieldToMainBackground().then(() => {
				multiJWP.setupPlayer(
					`_video_${target.dataset.video_id}`,
					target.dataset.video_uid,
					{
						noads: target.dataset.no_ads,
						article_url: target.dataset.video_article,
						is_downloadable: true,
					},
				);
			});

			// update data
			videoContainer.dataset.video_id = target.dataset.video_id;
			videoContainer.dataset.video_uid = target.dataset.video_uid;
			firstVideo.querySelector("h2").textContent = target.dataset.name;
			for (const el of document.querySelectorAll(".video-grid__item")) {
				el.classList.remove("active");
			}
			target.parentNode.classList.add("active");
		});
	}
}
